// extracted by mini-css-extract-plugin
export var typingIndicator = "_rg-0";